import { RefObject } from 'react';
import { maybe } from '@lwtears/lwt-common-frontend/lib/@common/util/maybe-util';
import makeStyles from '@mui/styles/makeStyles';
import DoublePageLayout from './DoublePageLayout';
import PageLayout from './PageLayout';
import usePage from '../../../../hooks/use-page';
import { shouldDisplaySinglePage } from '../../../../util/paging-util';

interface BookLayoutProps {
  // history?: any;
  children?: any;
  onePageBehavior?: boolean;
  pagination?: boolean;
  gameLayout?: boolean;
  bookRef: RefObject<HTMLDivElement>;
}

const BookLayout: React.FC<BookLayoutProps> = ({ bookRef, ...props }) => {
  const [{ noOfPages, currentPage, totalPages, zoomed, firstPage }] = usePage();
  const classes = useStyles();

  const renderOnePage =
    props.onePageBehavior === true ||
    shouldDisplaySinglePage(currentPage, noOfPages, totalPages, firstPage);

  const MaybeSinglePageLayout = maybe(PageLayout);
  const MaybeDoublePageLayout = maybe(DoublePageLayout);

  return (
    <div
      className={`${props.gameLayout ? classes.gameWrapper : classes.bookWrapper} ${
        zoomed ? classes.zoomedContent : ''
      } `}
      ref={bookRef}
    >
      <MaybeSinglePageLayout shouldRender={renderOnePage} {...props} />
      <MaybeDoublePageLayout shouldRender={!renderOnePage} {...props} />
    </div>
  );
};

const useStyles = makeStyles(() => ({
  bookWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '112.56vh',
    height: '76vh',
  },
  gameWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '87vw',
  },
  zoomedContent: {
    width: '149vh',
    height: '96vh',
    marginTop: '20vh',
  },
}));

export default BookLayout;
